import axios from 'axios';
import NotFoundError from './errors/notFound';

const RECAPTCHA_TOKEN_HEADER = 're-captcha-token';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export function checkStatus(params, captchaToken) {
  return axios.get(
    process.env.VUE_APP_CHECK_STATUS_URI,
    {
      params,
      headers: { [RECAPTCHA_TOKEN_HEADER]: captchaToken }
    }
  )
    .then(r => r.data)
    .catch((e) => {
      if (e.response?.status === 404) {
        throw new NotFoundError('Sorry, we can\'t find that request.');
      } else {
        throw new Error('We\'re sorry, but there has been an unexpected error. Please try again.');
      }
    });
}

export function getMaintenanceSchedule() {
  return axios.get(process.env.VUE_APP_MAINTENANCE_URI)
    .then(r => r.data);
}

export function submitFoiaRequest(data, captchaToken) {
  return axios.post(
    process.env.VUE_APP_SUBMIT_REQUEST_URI,
    data,
    {
      headers: { [RECAPTCHA_TOKEN_HEADER]: captchaToken }
    }
  )
    .then(r => r.data)
    .catch(() => {
      throw new Error('We\'re sorry, but there has been an error in submitting your request. Please try again.');
    });
}
